<div class="card-scoreboard_stats">
    <div class="card-scoreboard_stats-values card-scoreboard_stats-values-pair">
        <div class="card-scoreboard_stats-column">
            <div class="cell highlight"></div>
            <div class="cell highlight away-indicator" [msAutomation]="'marquee-prematch-away-indicator'">{{ awayIndicator }}</div>
            <div class="cell highlight"></div>
        </div>
    </div>
</div>
